import { render } from "./Offer92offWorkbooksBundle.vue?vue&type=template&id=366a5cac&scoped=true"
import script from "./Offer92offWorkbooksBundle.vue?vue&type=script&lang=js"
export * from "./Offer92offWorkbooksBundle.vue?vue&type=script&lang=js"

import "./Offer92offWorkbooksBundle.vue?vue&type=style&index=0&id=366a5cac&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366a5cac"],['__file',"src/views/post/Offer92offWorkbooksBundle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "366a5cac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('366a5cac', __exports__)) {
    console.log('reload')
    api.reload('366a5cac', __exports__)
  }
  
  module.hot.accept("./Offer92offWorkbooksBundle.vue?vue&type=template&id=366a5cac&scoped=true", () => {
    console.log('re-render')
    api.rerender('366a5cac', render)
  })

}


export default __exports__